// removed by extract-text-webpack-plugin
module.exports = {"appNavList":"NavigationLinks__appNavList__39FGx","appNavListItem":"NavigationLinks__appNavListItem__3LUpe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NavigationLinks/NavigationLinks.css
// module id = 241
// module chunks = 0